import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http'
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private snackbar : MatSnackBar,
  ) { }
  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 1500 });
  }
  openDeleteDialog(componentName: any, height: any, width: any, dataModel: any, maxwidth: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: maxwidth,
    });
  }

  openDialog(componentName: any, height: any, width: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
    });
  }

  // for Department listing 
  getAllDepartment(page:number,size:number){
    return this.http.get(
      environment.baseUrl+`admin/master/hrms/department?pageNo=${page}&size=${size}`
    )
  }
    getAllDepartmentV2(data){
    return this.http.put(
      environment.baseUrl+`admin/master/hrms/department/v2`, data
    )
  }

  // for Department  Search 
  getSearchDepartment(page:number,size:number,text:any){
    return this.http.get(
      environment.baseUrl+`admin/master/hrms/department/search?pageNo=${page}&size=${size}&text=${text}`
    )
  }

  //for add Department
  addDepartment(data:any){
    return this.http.post(
      environment.baseUrl+`admin/master/hrms/department`,data
    )
  }
  getActiveInActiveDepartmentCount(){
    return this.http.get(
      environment.baseUrl+`admin//master/hrms/dep/active/inactive`
    )
  }

  updateDepartment(data:any){
    return this.http.put(
      environment.baseUrl+`admin/master/hrms/department`,data
    )
  }

  changeToggleDepartment(status: any, id: any){
    return this.http.put(
      environment.baseUrl + `admin/master/hrms/department/status?active=${status}&id=${id}`,{}
    )
  }
// Delete  Department API
  deleteDepartment(departmentId:any){
    return this.http.delete(
      environment.baseUrl+`admin/master/hrms/department?id=${departmentId}`
    )}

    departmentFilter(data:any){
      return this.http.put(
        environment.baseUrl +`admin/master/hrms/department/filter`,data
      )
    }


    // for Designation listing 
  getAllDesignation(page:number,size:number){
    return this.http.get(
      environment.baseUrl+`admin/master/hrms/designation?pageNo=${page}&size=${size}`
    )
  }
  getActiveInActiveDesignationCount(){
    return this.http.get(
      environment.baseUrl+`admin//master/hrms/design/active/inactive`
    )
  }

   getAllDesignationV2(data){
    return this.http.put(
      environment.baseUrl+`admin/master/hrms/designation/v2`, data
    )
  }
  // for Designation  Search 
  getSearchdesignation(page:number,size:number,text:any){
    return this.http.get(
      environment.baseUrl+`admin/master/hrms/designation/search?pageNo=${page}&size=${size}&text=${text}`
    )
  }

  //for add Designation
  addDesignation(data:any){
    return this.http.post(
      environment.baseUrl+`admin/master/hrms/designation`,data
    )
  }

  updateDesignation(data:any){
    return this.http.put(
      environment.baseUrl+`admin/master/hrms/designation`,data
    )
  }

  changeToggleDesignation(status: any, id: any){
    return this.http.put(
      environment.baseUrl + `admin/master/hrms/designation/status?active=${status}&id=${id}`,{}
    )
  }
// Delete  Designation API
  deleteDesignation(designationId:any){
    return this.http.delete(
      environment.baseUrl+`admin/master/hrms/designation?id=${designationId}`
    )}

    // filter for desgination 
    designationFilter(data:any){
      return this.http.put(
        environment.baseUrl + `admin/master/hrms/designation/filter`,data
      )
    }


       addCategory(data:any){
      return this.http.post(
        environment.baseUrl+`admin/social-template/category`,data
      )
       }
          addGoal(data:any){
      return this.http.post(
        environment.baseUrl+`admin/social-template/goal`,data
      )
    }
       deleteCategory(categoryId:any){
      return this.http.delete(
        environment.baseUrl+`admin/social-template/category/${categoryId}`
      )
    }
         deleteGoal(goalId:any){
      return this.http.delete(
        environment.baseUrl+`admin/social-template/goal/${goalId}`
      )
    }

         deleteSmmTemplate(id:any){
      return this.http.delete(
        environment.baseUrl+`admin/social-template/template/${id}`
      )
    }
        getCategoryList(data){
          return this.http.put(
            environment.baseUrl+`admin/social-template/category/filter`,data
          )
        }
             getGoalsList(data){
          return this.http.put(
            environment.baseUrl+`admin/social-template/goal/filter`,data
          )
        }
  getPlatformsList(): Observable<{ data: string[] }> {
    return this.http.get<{ data: string[] }>(
      `${environment.baseUrl}admin/social-template/platform`
    );
  }

              getSmmTemplatesList(data){
          return this.http.put(
            environment.baseUrl+`admin/social-template/template/filter`,data
          )
        }
            // for search country in template 
    getSearchCategory(data){
      return this.http.put(
        environment.baseUrl+`admin/social-template/category/filter`,data
      )
    }
      getSearchGoal(data){
      return this.http.put(
        environment.baseUrl+`admin/social-template/goal/filter`,data
      )
    }

       createTemplate(data:any){
      return this.http.post(
        environment.baseUrl+`admin/social-template/template`,data
      )
       }
       updateTemplate( payload: any) {
   return this.http.post(
        environment.baseUrl+`admin/social-template/template`,payload
      )
}

       
         getBusinessIndustry(page: number, size: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/industry/count?pageNo=${page}&size=${size}`
    );
  }
subIndustryFilter(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/master/business/sub/filter`,
      data
    );
  }
  getPlatforms() {
  return this.http.get<{ data: string[] }>(
    environment.baseUrl + `admin/social-template/platform`
  );
}
 getSearchSubIndustry(page: number, size: number, searchText: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/sub/search?pageNo=${page}&size=${size}&text=${searchText}`
    );
  }
    


}